import { useEffect, useState } from 'react'
import Helpers from '../../../Helpers/Helpers'
import CategoryCard from '../../components/card/CategoryCard'
import BannerCarousel from '../../components/BannerCarousel'

const CategoriesComponent = ({ title }) => {
  const helpers = Helpers()
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    const fetchCats = async () => {
      try {
        const resp = await helpers.httpRequest('/category?populate=true', 'GET')
        if (resp.status === 'success') {
          setCategories(resp.data)
        }
      } catch (e){ console.error(e)} finally { setLoading(false) }
    }
    fetchCats()
  },[])

  return (
    <>
      <BannerCarousel section="categories_offers" />
      <section className="as_shop_wrapper as_padderTop80 as_padderBottom90">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 col-md-6 offset-md-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search categories..."
                value={searchTerm}
                onChange={e=>setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            {loading ? (
              <div className="col-12 text-center">Loading...</div>
            ) : (
              categories
                .filter(cat=>cat.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .map(cat => <CategoryCard key={cat._id} category={cat} />)
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default CategoriesComponent 